import React, { ReactNode } from 'react';
import { Typography, Box, Paper, Divider } from '@mui/material';

interface ChartContainerProps {
  title: string;
  children: ReactNode;
  actionButton?: ReactNode;
}

const ChartContainer: React.FC<ChartContainerProps> = ({ title, children, actionButton }) => {
  return (
    <Paper elevation={3} sx={{ 
      p: 3, 
      height: '100%', 
      borderRadius: 2,
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        transform: 'translateY(-5px)'
      }
    }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        {actionButton}
      </Box>
      <Divider sx={{ mb: 2 }} />
      {children}
    </Paper>
  );
};

export default ChartContainer;
